export default "__VITE_ASSET__CR3U4QPH__"